"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GLOBAL_PARAMETERS = exports.GlobalParameter = void 0;
var GlobalParameter;
(function (GlobalParameter) {
    GlobalParameter["OCEANS"] = "oceans";
    GlobalParameter["OXYGEN"] = "oxygen";
    GlobalParameter["TEMPERATURE"] = "temperature";
    GlobalParameter["VENUS"] = "venus";
    GlobalParameter["MOON_HABITAT_RATE"] = "moon-habitat";
    GlobalParameter["MOON_MINING_RATE"] = "moon-mining";
    GlobalParameter["MOON_LOGISTICS_RATE"] = "moon-logistics";
})(GlobalParameter = exports.GlobalParameter || (exports.GlobalParameter = {}));
exports.GLOBAL_PARAMETERS = [
    GlobalParameter.OCEANS,
    GlobalParameter.OXYGEN,
    GlobalParameter.TEMPERATURE,
    GlobalParameter.VENUS,
    GlobalParameter.MOON_HABITAT_RATE,
    GlobalParameter.MOON_MINING_RATE,
    GlobalParameter.MOON_LOGISTICS_RATE,
];
